/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type StaticAssetKey =
  (typeof StaticAssetKey)[keyof typeof StaticAssetKey];

export const StaticAssetKey = {
  nori_approach_phrase: "nori_approach_phrase",
} as const;
